import { clientFetch } from '~/lib/.client/fetch';
import { userStore } from '~/lib/stores/user';
import { webcontainer } from '~/lib/webcontainer';
import { logger } from '~/utils/logger';

export type CorsToken = {
  token: string;
  expiresAt: number;
};

let corsEnabled = false;

const proxyAddress = import.meta.env.DEV
  ? 'https://cors-proxy-staging.stackblitz.workers.dev'
  : 'https://cors-proxy-production.stackblitz.workers.dev';

export function setCORSProxy(value: boolean) {
  if (value !== corsEnabled) {
    corsEnabled = value;

    webcontainer.then((webcontainer) => {
      webcontainer.internal.setCORSProxy(
        corsEnabled
          ? {
              address: proxyAddress,
              domains: [],
            }
          : undefined,
      );
    });
  }
}

const dispose = userStore.loggedIn.subscribe((loggedIn) => {
  if (loggedIn) {
    dispose();
    getCORSAuthToken();
  }
});

let timeout: NodeJS.Timeout;

async function getCORSAuthToken() {
  clearTimeout(timeout);

  try {
    const webcontainerInstance = await webcontainer;
    const request = await clientFetch('/api/token/cors');
    const body = await request.json<CorsToken | { errorMessage: string }>();

    if ('errorMessage' in body) {
      throw new Error(`CORS Token Error: ${body.errorMessage}`);
    }

    const { token, expiresAt } = body;

    // refresh the token 5 mins before it's due to expire
    const refreshPeriod = expiresAt * 1000 - Date.now() - 5 * 60 * 1000;

    timeout = setTimeout(getCORSAuthToken, refreshPeriod);

    await webcontainerInstance.internal.setCORSAuthToken(token);
  } catch (error: any) {
    logger.error(error.message);
  }
}
